import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import swal from 'sweetalert';

const CustomerAddressComponent = ({addressParam, indexa, triggerLoop, classes = ""}) => {
  const navigate = useNavigate();
  const [expand, setExpand] = useState(false);
  const address = addressParam;

  const makeAddressPrimary = (id) => {
    axios.get('customer-address-primary/' + id)
      .then((res) => {
        swal('Customer address has been set primary!', {
          icon: "success",
        });
        triggerLoop(id);
      }).catch(function (error) {
      console.log(error);
    });
  }

  const deleteCustomerAddress = (id) => {
    swal({
      title: "Are you sure?",
      text: 'You want to delete this address?',
      icon: "warning",
      buttons: true,
      dangerMode: true,
      confirm: {
        text: "Yes",
        value: true,
        visible: true,
        className: "",
        closeModal: true
      }
    }).then((result) => {
      if (result == true) {
        axios.delete('customerAddresses/' + id).then(function (res) {
          console.log(res);
          if (res.status == 200) {
            swal('The address has been deleted!', {
              icon: "success",
            });
            triggerLoop(id);
            return true;
          } else {
            return false;
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    });
  }

  return (
    <>
      <div key={indexa} className={classes ? " " + classes : ''}>
        {!address?.primary &&
        (
          <div className="customer-address-edit-btn-div make-primary">
            <i
              className="fas fa-shield-alt d-inline fs-3"
              title="Make Primary"
              onClick={() => {
                makeAddressPrimary(address?.id);
              }}
            ></i>
          </div>
        )
        }
        <div className="customer-address-edit-btn-div edit">
          <i
            className="fas fa-edit mr-3 d-inline fs-3"
            title="Edit"
            onClick={() => {
              navigate(`/addresses/${address.id}/edit`)
            }}
          ></i>
        </div>
        <div className="customer-address-edit-btn-div">
          <i
            className="far fa-trash-alt d-inline fs-3"
            title="Delete"
            onClick={() => {
              deleteCustomerAddress(address.id);
            }}
          >
          </i>
        </div>
        <div className="address pb-5 pt-10">
          <h5 className="d-block">
            <div
              className="text-muted d-inline-block py-2 fw-bolder fs-4 ls-1 user-select-none color-dark-grey">
              {address?.address_type}
            </div>
            {address?.primary &&
            (<span
              className="badge badge-light-primary d-inline-block ml-3 py-2 color-primary fw-bolder fs-8 ls-1 user-select-none">
                                <i className="fas fa-star mr-2 color-primary"></i>
                                Primary
                            </span>)
            }
            <div
              className="d-inline-block bg-secndary py-2 cursor-pointer float-right"
              onClick={() => {
                setExpand(!expand)
              }}
              title={expand ? "" : "Expand"}
            >
              <i className={`fas fa-chevron-${expand ? "up" : "down"} text-secondary fs-1 t-1-rem`}></i>
            </div>

            <div className="fw-bolder ls-1 mb-2 mt-4 mr-3">
              <span className="fw-normal">Address: {address?.address}</span>
            </div>
            <div className={`accordeon-div pt-3${expand ? "" : " d-none"}`}>
              <div className="fw-bolder ls-1 mb-2">
                First Name:
              </div>
              <div className="fw-normal ls-1 mb-7">
                {address?.first_name}
              </div>
              <div className="fw-bolder ls-1 mb-2 mt-3">
                Last Name:
              </div>
              <div className="fw-normal ls-1 mb-7">
                {address?.last_name}
              </div>
              <div className="fw-bolder ls-1 mb-2 mt-3">
                Personal Number:
              </div>
              <div className="fw-normal ls-1 mb-7">
                {address?.personal_number}
              </div>
              <div className="fw-bolder ls-1 mb-2 mt-3">
                Phone:
              </div>
              <div className="fw-normal ls-1 mb-7">
                {address?.phone}
              </div>
            </div>
          </h5>
        </div>
      </div>
    </>
  )
}

export default CustomerAddressComponent;